import Vue from 'vue'
import {Validator} from 'vee-validate';

export const setLanguage = ({commit}, language) => {
    commit("setLanguage", language);

    Vue.prototype.$polyglot.setLang({lang: language});
    Validator.localize(language);
};


// WEBPACK FOOTER //
// ./src/store/actions/lang.js